/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import Loader from "components/Loader";
import {DRIVERS_NAMES_CHECKIN_ALLOWED} from "helpers/config";
import {LightBulbIcon} from "@heroicons/react/24/outline";
import ButtonSubmit from "pages/Front/Booking/components/ButtonSubmit";
import useNavigation, {RouteName} from "utils/hooks/useNavigation";
import {BookingPaidContext} from "pages/Front/Booking/BookingPaid";

const BookingPaidCheckin = () => {
    const {historyPush} = useNavigation();

    const {t} = useTranslation();
    const bookingPaidContext = useContext(BookingPaidContext);

    if (!bookingPaidContext || !bookingPaidContext.hall || !bookingPaidContext.payment || !bookingPaidContext.payment.reservation) {
        return <Loader />;
    }

    return (
        <div className={"BookingPaidCheckin w-full space-y-2 sm:space-y-8"}>
            <CardComponent className={"text-sm sm:text-lg"}>
                <div className={"flex flex-col space-y-2 mt-4 items-center justify-center text-center font-medium"}>
                    <h4 className={"text-2xl uppercase text-black"}>{t("Checkin Code")}</h4>
                    <h4 className={"text-4xl uppercase font-black text-gray-900 my-4"}>{bookingPaidContext.payment.reservation.guid}</h4>
                    <span className={"px-4"}>{t("Please use this QR code at Check-in")}.</span>
                    <div className={"flex flex-col items-center pt-4 pb-8"}>
                        <img alt={"Reservation QR code"} className={"w-48 h-48 rounded-md"} src={bookingPaidContext.payment.reservation.qrPng} />
                    </div>
                </div>
            </CardComponent>
            {DRIVERS_NAMES_CHECKIN_ALLOWED && (
                <CardComponent className={"text-sm sm:text-lg"}>
                    <div className={"flex flex-col space-y-2 items-center justify-center"}>
                        <div className="flex flex-col space-y-2 items-center">
                            <div className={"flex flex-row space-x-2 items-center"}>
                                <LightBulbIcon className={"w-4 h-4"} />
                                <h4 className={"text-sm sm:text-lg  font-black text-primary-800"}>{t("Advice")}</h4>
                            </div>
                            <span className={"px-4 text-center"}>{t("Save time at Check-in and write names of your group")}:</span>
                            <ButtonSubmit
                                buttonType={"cta"}
                                className={"rounded-md"}
                                icon={"persons"}
                                id={"GoToCheckin"}
                                label={t("Write names")}
                                onClick={() =>
                                    historyPush(
                                        RouteName.Checkin,
                                        "",
                                        bookingPaidContext.payment?.package,
                                        bookingPaidContext.payment?.reservation?.packagesCart
                                    )
                                }
                            />
                        </div>
                    </div>
                </CardComponent>
            )}
        </div>
    );
};

export default BookingPaidCheckin;
